/* eslint-disable filenames/match-regex */
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const CURRENT_LOCATION = 'CURRENT_LOCATION';
export const GET_TABLES = 'GET_TABLES';
export const CHANGE_LOCATION_CODE = 'CHANGE_LOCATION_CODE';
export const GET_LOCATION_CODE = 'GET_LOCATION_CODE';

export const getLocations = (payload) => ({
    type: GET_LOCATIONS,
    payload
});


export const getLocationsCode = (payload) => ({
    type: GET_LOCATION_CODE,
    payload
});


export const getTables = (payload) => ({
    type: GET_TABLES,
    payload
});

export const changeCurrentLocations = (payload) => ({
    type: CURRENT_LOCATION,
    payload
});


export const changeCurrentLocationsCode = (payload) => ({
    type: CHANGE_LOCATION_CODE,
    payload
});
